<h1 mat-dialog-title>Codigos Qr de los desportistas</h1>
<div style="width: 100%">
  <button mat-raised-button color="primary" (click)="downloadAsPDF()">
    Guardar en PDF
  </button>
</div>

<div mat-dialog-content>
  <div
    id="divContenedor"
    fxLayout="row wrap"
    fxLayoutAlign="space-around stretch"
  >
    <div fxFlex="40" *ngFor="let usr of data">
      <div fxLayout="column" fxLayoutAlign="space-around center">
      <!--   <div><qr-code [value]="usr?.qr" [size]="400"></qr-code></div> -->
      <div class="qrcodeImage">
        <qrcode [qrdata]="usr?.qr" [width]="400" [errorCorrectionLevel]="'M'" [cssClass]="'demoBorder'"></qrcode>
        
      </div>
        <div>{{ usr.documento }}</div>
        <div>{{ usr.nombre }}</div>
      </div>
    </div>
  </div>
</div>
